import React, {Component} from 'react';

export default class SocialMediaLinksContent extends Component {
  /** @function
   * Renders the Social Media Links Content component.
   */
  render() {
    var links = [];
    if(this.props.facebook) {
      links.push(
        <a key="facebook" href={this.props.facebook} target="_blank">
          <i className="fa fa-facebook"></i>
        </a>
      );
    }
    if(this.props.twitter) {
      links.push(
        <a key="twitter" href={this.props.twitter} target="_blank">
          <i className="fa fa-twitter"></i>
        </a>
      );
    }
    if(this.props.instagram) {
      links.push(
        <a key="instagram" href={this.props.instagram} target="_blank">
          <i className="fa fa-instagram"></i>
        </a>
      );
    }
    if(this.props.googlePlus) {
      links.push(
        <a key="google+" href={this.props.googlePlus} target="_blank">
          <i className="fa fa-google-plus"></i>
        </a>
      );
    }
    return (
      <div className="social-media-links">
        {links}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/social-media-links-content.js